import(/* webpackMode: "eager" */ "/home/claude/hadatha/hadatha/src/app/gallery/page.tsx");
